/**
 * axiosの共通設定
 */
import axios from 'axios';

const baseURL = process.env.VUE_APP_APIBASE;

const instance = axios.create({
  baseURL,
  responseType: 'json',
});

// リクエストインターセプターで動的にヘッダーを設定
instance.interceptors.request.use(
  (config) => {
    // LocalStorageからトークンを取得
    const projectName = process.env.VUE_APP_PROJECTNAME;
    const storedData = localStorage.getItem(projectName);

    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        if (parsedData.auth && parsedData.auth.token) {
          config.headers.Authorization = parsedData.auth.token;
        }
      } catch (e) {
        console.error('Failed to parse localStorage data:', e);
      }
    }

    return config;
  },
  (error) => Promise.reject(error),
);

export default instance;
